import { fabric } from 'fabric';

export interface FitTextOptions {
  text: string;
  width: number;
  height: number;
  fontFamily: string;
  fontWeight: string | number;
  fontStyle?: string;
  maxFontSize: number;
  minFontSize: number;
}

const PROBE_FONT_SIZE = 100;
const SAFETY_MARGIN = 0.95;

export function fitTextToBox(options: FitTextOptions): number {
  const { text, width, height, fontFamily, fontWeight, fontStyle, maxFontSize, minFontSize } = options;
  if (!text || width <= 0 || height <= 0) return minFontSize;

  const probe = new fabric.Text(text, {
    fontSize: PROBE_FONT_SIZE,
    fontFamily,
    fontWeight,
    fontStyle: normalizeFontStyle(fontStyle),
  });

  const probeWidth = probe.width ?? 0;
  const probeHeight = probe.height ?? 0;
  if (probeWidth <= 0 || probeHeight <= 0) return minFontSize;

  const scale = Math.min(width / probeWidth, height / probeHeight) * SAFETY_MARGIN;
  const raw = PROBE_FONT_SIZE * scale;
  return clamp(raw, minFontSize, maxFontSize);
}

function clamp(value: number, min: number, max: number): number {
  if (Number.isNaN(value)) return min;
  return Math.max(min, Math.min(max, value));
}

function normalizeFontStyle(value: string | undefined): '' | 'normal' | 'italic' | 'oblique' {
  if (value === 'italic' || value === 'oblique' || value === 'normal' || value === '') return value;
  return 'normal';
}
